import { render } from "./SurveyImprovementCard.vue?vue&type=template&id=2ec724c5"
import script from "./SurveyImprovementCard.vue?vue&type=script&lang=js"
export * from "./SurveyImprovementCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__